import { Link } from '@ds/components'
import type { TSeoNavEntry } from '../types'
import styles from './SeoNav.module.css'

type TSeoNavProps = {
    label: string
    entries: readonly TSeoNavEntry[]
}

// Nested, visually-hidden crawler navigation (mirrors audio-web's SEO nav). The visible interactive
// nav is rendered client-side; this exists purely for crawlers/assistive tech.
export const SeoNav = ({ label, entries }: TSeoNavProps) => (
    <nav className={styles.seoNav} role="navigation" aria-label={label}>
        <ul>
            {entries.map(entry =>
                entry.kind === 'group' ? (
                    <li key={entry.label}>
                        <p>{entry.label}</p>
                        <ul>
                            {entry.links.map(link => (
                                <li key={link.href}>
                                    <Link variant="primary" href={link.href}>
                                        {link.label}
                                    </Link>
                                    {link.description ? <p>{link.description}</p> : null}
                                </li>
                            ))}
                        </ul>
                    </li>
                ) : (
                    <li key={entry.href}>
                        <Link variant="primary" href={entry.href}>
                            {entry.label}
                        </Link>
                    </li>
                ),
            )}
        </ul>
    </nav>
)
